import { Layers } from 'lucide-react'

import { AppraisalSection } from '@/components/deals/appraisal/AppraisalSection'
import { BrrrFlipScheme } from '@/components/deals/appraisal/BrrrFlipScheme'
import { CommercialMixedUseScheme } from '@/components/deals/appraisal/CommercialMixedUseScheme'
import { HmoScheme } from '@/components/deals/appraisal/HmoScheme'

export function SchemePanel({
  currentStrategy,
  brrrState,
  hmoState,
  commercialState,
  isCoWork,
  postcodeArea,
  showValidationErrors,
  onBrrrStateChange,
  onHmoStateChange,
  onCommercialStateChange,
}) {
  return (
    <AppraisalSection title="Scheme" icon={Layers}>
      {renderScheme({
        currentStrategy,
        brrrState,
        hmoState,
        commercialState,
        isCoWork,
        postcodeArea,
        showValidationErrors,
        onBrrrStateChange,
        onHmoStateChange,
        onCommercialStateChange,
      })}
    </AppraisalSection>
  )
}

function renderScheme({
  currentStrategy,
  brrrState,
  hmoState,
  commercialState,
  isCoWork,
  postcodeArea,
  showValidationErrors,
  onBrrrStateChange,
  onHmoStateChange,
  onCommercialStateChange,
}) {
  if (currentStrategy === 'HMO') {
    return (
      <HmoScheme
        state={hmoState}
        postcodeArea={postcodeArea}
        showValidationErrors={showValidationErrors}
        onStateChange={onHmoStateChange}
      />
    )
  }

  if (
    currentStrategy === 'Commercial / Mixed-Use' ||
    currentStrategy === 'Commercial Conversion'
  ) {
    return (
      <CommercialMixedUseScheme
        state={commercialState}
        isCoWork={isCoWork}
        postcodeArea={postcodeArea}
        showValidationErrors={showValidationErrors}
        onStateChange={onCommercialStateChange}
      />
    )
  }

  return (
    <BrrrFlipScheme
      state={brrrState}
      postcodeArea={postcodeArea}
      showValidationErrors={showValidationErrors}
      onStateChange={onBrrrStateChange}
    />
  )
}
